<template>
  <div class="integration-modal">
    <div class="integration-modal__header">
      <div class="integration-modal__title">Add New Integration</div>
    </div>
    <div class="integration-modal__body">
      <base-select class="integration-modal__select"
                   :class="{'integration-modal__select_err': isErr}"
                   :options="options"
                   alignLeft
                   showTopBorder
                   shiftLabelRight
                   :disabled="isButtonDisabled"
                   v-model="selectedService"
                   :selectStyle="{height: '60px!important'}"
                   placeholder="Select service"
                   @change="handleIntegration"/>
      <template v-if="selectedService === 'cloudflare'">
        <input
          class="integration-modal__input"
          placeholder="Email"
          borderless
          v-model="cloudflareEmail"
        />
        <input
          class="integration-modal__input"
          placeholder="Account ID"
          borderless
          v-model="cloudflareAccountId"
        />
        <input
          class="integration-modal__input"
          placeholder="API Key"
          borderless
          v-model="cloudflareApiKey"
        />
      </template>
      <template v-else-if="selectedService === 'shopify'">
        <input
          class="integration-modal__input"
          placeholder="Access Token"
          borderless
          v-model="shopifyAccessToken"
        />
      </template>
    </div>
    <div class="integration-modal__footer">
      <button class="integration-modal__button integration-modal__button_cancel"
              :class="{'integration-modal__button_disabled': isButtonDisabled}"
              @click="close">cancel</button>
      <button class="integration-modal__button integration-modal__button_add"
              :class="{'integration-modal__button_disabled': isButtonDisabled}"
              @click="addIntegration">add</button>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'
import _ from 'lodash'
import { mapState } from 'vuex'

const options = [
  {
    label: 'Asana',
    value: 'asana'
  },
  {
    label: 'Cloudflare',
    value: 'cloudflare'
  },
  {
    label: 'Shopify',
    value: 'shopify'
  }
]

export default {
  name: 'AddNewIntegration',
  mixins: [BaseModalMixins],
  props: {
    availableIntegrations: {
      type: Array,
      default: () => []
    },
    integrationLinks: {
      type: Object,
      require: true
    }
  },
  mounted () {
    this.options = this.options.filter((item) => this.availableIntegrations.includes(item.value))
  },
  data () {
    return {
      options: _.cloneDeep(options),
      selectedService: null,
      isErr: false,
      isButtonDisabled: false,
      cloudflareEmail: '',
      cloudflareApiKey: '',
      cloudflareAccountId: '',
      shopifyAccessToken: ''
    }
  },
  methods: {
    addIntegration () {
      if (!this.selectedService) {
        this.isErr = true
        return
      }
      if (this.selectedService === 'cloudflare') {
        this.$emit('cloudflare', { email: this.cloudflareEmail, apiKey: this.cloudflareApiKey, accountId: this.cloudflareAccountId })
        this.$emit('close')
        return
      } else if (this.selectedService === 'shopify') {
        this.$emit('shopify', { accessToken: this.shopifyAccessToken })
        this.$emit('close')
        return
      }
      window.location.replace(this.integrationLinks[this.selectedService])
      this.isButtonDisabled = true
    },
    handleIntegration (value) {
      this.selectedService = value
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
  .integration-modal {
    background-color: #fff;
    padding: 40px;
    border-radius: 15px;

    &__select {
      &_err {
        border: 1px solid $rfx-light-red;
      }
    }

    &__input {

      display: flex;
      flex-direction: column;
      position: relative;
      margin-top: 25px;
      // margin-left: 10px;
      // border: 0;
      background-color: #fff;
      border: 1px solid $rfx-light-steel;
      padding: 20px;
      border-radius: 4px;
      outline: none;

        width: 100%;
        box-sizing: border-box;
        padding-right: 60px;
        font-weight: 500;
        @include ellipsis;
    }

    &__title {
      margin: 0 auto;
      padding-bottom: 40px;
      text-align: center;
      font-size: 24px;
      line-height: 32px;
      color: $rfx-dark-march;
      font-weight: bold;
    }

    &__button {
      width: 100px;
      height: 40px;
      font-size: 10px;
      font-weight: 900;
      cursor: pointer;
      text-transform: uppercase;
      border-radius: 8px;
      outline: none;
      border: none;

      &_cancel {
        color: $rfx-dark-march;
        margin-right: 30px;
      }

      &_add {
        color: #fff;
        background-color: $rfx-dark-march;
      }

      &_disabled {
        pointer-events: none;
        opacity: .5;
      }
    }

    &__footer {
      margin-top: 40px;
      display: flex;
      align-items: center;
      padding-left: 340px;
    }
  }
</style>
